<template>
  <div class="xhs-preview">
    <div class="p-head">
      <span class="t">发布效果预览</span>
      <!-- ★出图之后才给出口：这块的终点是"发出去"，不给入口等于让用户自己去找小红书。
           复制和跳转挨在一起 —— 先把文案揣走再出门，顺序反了就得再切回来一趟 -->
      <!-- ★只有定稿之后才给"带走"和"出去"：闸门③那一版还可能被改掉，
           这时候放人去发布，等于让他发一个下一秒就作废的版本 -->
      <template v-if="finalized">
        <el-button size="mini" plain class="cp" :loading="downloading" @click="downloadAll">
          <i v-if="!downloading" class="el-icon-download"></i>
          {{ downloading ? downloadTip : '下载配图及文案' }}
        </el-button>
        <el-button type="primary" size="mini" class="go" @click="goPublish">
          前往发布<i class="el-icon-top-right"></i>
        </el-button>
      </template>
      <span v-if="images.length" class="c" :class="{ solo: !finalized }">{{ current + 1 }}/{{ images.length }}</span>
    </div>

    <!-- 手机壳 -->
    <div class="phone">
      <div class="notch"></div>
      <div class="screen">
        <!-- 有成品：模拟一篇真实笔记 -->
        <template v-if="images.length">
          <div class="img-wrap">
            <el-image :src="images[current]" fit="cover" class="shot" />
            <!-- 图集指示点：小红书笔记就是这么翻的 -->
            <div v-if="images.length > 1" class="dots">
              <span
                v-for="(u, i) in images"
                :key="i"
                class="dot"
                :class="{ on: i === current }"
                @click="current = i"
              ></span>
            </div>
            <div v-if="images.length > 1" class="nav prev" @click="step(-1)">‹</div>
            <div v-if="images.length > 1" class="nav next" @click="step(1)">›</div>
          </div>

          <div class="note">
            <div class="n-title">{{ noteCopy ? noteCopy.title : task.title }}</div>
            <div v-if="noteCopy" class="n-body">{{ noteCopy.body }}</div>
            <div v-if="noteCopy" class="n-tags">
              <span v-for="(t, i) in noteCopy.tags" :key="i" class="tag">#{{ t }}</span>
            </div>
            <div class="n-bar">
              <span>♡ 收藏</span><span>♡ 点赞</span><span>💬 评论</span>
            </div>
          </div>
        </template>

        <!-- ★没成品时也要说话，不能是一块空白让人以为坏了 -->
        <div v-else class="placeholder">
          <i :class="phState.icon"></i>
          <div class="ph-title">{{ phState.title }}</div>
          <div class="ph-desc">{{ phState.desc }}</div>
        </div>
      </div>
    </div>

    <!-- 发布页得一张张手动传图，所以图必须能落到本地。
         没做 zip：对方要的就是散图，打了包用户还得先解压，反而多一步 -->
    <div v-if="finalized" class="p-tip">这就是发到小红书后大致的样子</div>
    <!-- 待确认那一版：图能看，但先别让人下载/发布 -->
    <div v-else-if="images.length" class="p-tip pending">
      这是等你确认的版本 · 左边定稿后可以下载和发布
    </div>
  </div>
</template>

<script>
import { XHS_PUBLISH_URL } from '../constants'

export default {
  name: 'XhsPreview',
  props: {
    task: { type: Object, default: null },
    /** form = 还在填表；task = 已经在跑/看某个任务 */
    mode: { type: String, default: 'form' },
    /** 闸门③挂起时那一版的图（还没定稿），定稿后被 result.images 取代 */
    pendingImages: { type: Array, default: () => [] },
  },
  data() {
    return { current: 0, downloading: false, downloadTip: '' }
  },
  computed: {
    /**
     * 优先用定稿结果；还没定稿就用闸门③里那一版。
     * ★闸门③的时候图其实已经渲好也传好了 —— 右边却还写着"等你确认"，
     *   而左边偏偏在问"看看还要不要改"。要看的东西不给看，这个闸门就没法判断。
     */
    images() {
      const done = (this.task && this.task.result && this.task.result.images) || []
      if (done.length) return done
      return this.pendingImages || []
    },
    noteCopy() {
      return (this.task && this.task.result && this.task.result.noteCopy) || null
    },
    /** 已定稿（有最终成品）—— 下载/复制/发布都以它为准 */
    finalized() {
      return ((this.task && this.task.result && this.task.result.images) || []).length > 0
    },
    /** 没成品时右侧显示什么 —— 按当前处在哪一步给不同的话 */
    phState() {
      if (this.mode === 'form' || !this.task) {
        return {
          icon: 'el-icon-picture-outline',
          title: '还没有内容',
          desc: '左边填完点「开始生成」，成品会在这里按小红书的样子预览',
        }
      }
      const s = this.task.status
      if (s === 'awaiting_review') {
        return { icon: 'el-icon-view', title: '等你确认', desc: '左边确认之后继续，出图了这里就能看效果' }
      }
      if (s === 'failed') {
        return { icon: 'el-icon-warning-outline', title: '这次没成功', desc: this.task.errorMsg || '点数已退回，可以重新发起' }
      }
      if (s === 'cancelled') {
        return { icon: 'el-icon-close', title: '已取消', desc: '点数已退回' }
      }
      return { icon: 'el-icon-loading', title: '正在生成', desc: '出图后这里会显示发布效果' }
    },
  },
  watch: {
    // 换任务时回到第一张，否则会停在上一个任务的页码上
    'task.guid'() {
      this.current = 0
    },
  },
  methods: {
    /**
     * 去小红书发布。
     * ★noopener：不带这个，被打开的页面能通过 window.opener 反过来操作本站，
     *   而且新标签页会和本页共用进程，对方卡了这边也跟着卡。
     */
    goPublish() {
      window.open(XHS_PUBLISH_URL, '_blank', 'noopener')
    },

    /**
     * 标题 + 正文 + 话题一次进剪贴板。
     * ★用 textarea + execCommand 而不是 navigator.clipboard：后者只在 https/localhost 下可用，
     *   内网 http 访问时会静默失败 —— 复制这种事失败了用户是察觉不到的。
     */
    /**
     * 标题 + 正文 + 话题，打进压缩包里的 文案.txt。
     * ★这里不再单独放"复制文案"按钮：压缩包已经带着 txt，
     *   左边成品卡还留着标题/正文/标签的分段复制（发帖时本来就要分开粘）。
     */
    noteText() {
      const c = this.noteCopy
      if (!c) return ''
      const tags = (c.tags || []).map((t) => '#' + t).join(' ')
      return [c.title, '', c.body, '', tags].join('\n').trim()
    },

    /** 文件名前缀：拿标题，去掉文件名里不能有的字符 */
    baseName() {
      const raw = (this.noteCopy && this.noteCopy.title) || (this.task && this.task.title) || '小红书套图'
      return raw.replace(/[\\/:*?"<>|\s]+/g, '_').slice(0, 40)
    },

    /**
     * 打包下载：N 张图 + 一份文案 txt，压成一个 zip。
     *
     * ★原来是逐张触发下载 —— 浏览器会弹"是否允许多个下载"，落进下载目录还散成一堆，
     *   用户得自己收拾。发小红书本来就是"一次带走一整套"，一个包才对得上这个动作。
     * ★在前端打包而不是让后端压：图片浏览器本来就已经下过一次（预览在显示它们），
     *   后端压还要先把几 MB 从 COS 拉回服务器再吐出去，白烧一遍带宽。
     */
    async downloadAll() {
      if (this.downloading || !this.images.length) return
      this.downloading = true
      const base = this.baseName()
      try {
        // 按需加载：JSZip 有一百多 KB，没人点下载就不该让它进首屏
        const JSZip = (await import('jszip')).default
        const zip = new JSZip()

        for (let i = 0; i < this.images.length; i++) {
          this.downloadTip = `打包中 ${i + 1}/${this.images.length}`
          const res = await fetch(this.images[i])
          if (!res.ok) throw new Error('HTTP ' + res.status)
          zip.file(`${String(i + 1).padStart(2, '0')}.png`, await res.blob())
        }

        // 文案跟图一起打包 —— 发帖时图和字是一起用的，分开给等于让用户再回来一趟
        if (this.noteCopy) {
          zip.file('文案.txt', this.noteText())
        }

        this.downloadTip = '生成压缩包…'
        const blob = await zip.generateAsync({ type: 'blob' })
        const href = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = href
        a.download = `${base}.zip`
        document.body.appendChild(a)
        a.click()
        a.remove()
        // ★必须 revoke：整包好几 MB，不放的话每下一次都在内存里留一份
        setTimeout(() => URL.revokeObjectURL(href), 1000)

        this.$message.success('打包好了，图和文案都在里面')
      } catch (e) {
        console.warn('[xhs-preview] 打包下载失败', e)
        this.$message.error('打包失败，可以点开大图右键另存')
      } finally {
        this.downloading = false
        this.downloadTip = ''
      }
    },
    step(d) {
      const n = this.images.length
      if (!n) return
      this.current = (this.current + d + n) % n
    },
  },
}
</script>

<style lang="scss">
.xhs-preview {
  width: 360px;
  flex-shrink: 0;
  border-left: 1px solid #ebedf0;
  background: #fafbfc;
  padding: 18px 20px 24px;
  overflow-y: auto;

  .p-head {
    display: flex;
    /* 有按钮之后不能再 baseline 对齐，按钮会比文字掉下去半行 */
    align-items: center;
    margin-bottom: 14px;
    .t { font-size: 14px; font-weight: 600; color: #1f2329; }
    /* 靠 margin-left:auto 顶到右边，比 space-between 稳 —— 这几颗按钮是有无不定的 */
    .cp { margin-left: auto; padding: 5px 9px; }
    .go { margin-left: 6px; padding: 5px 9px; i { margin-left: 3px; } }
    .c { margin-left: 8px; font-size: 12px; color: #8a8f98; }
    /* 没有按钮陪着时（未定稿），它自己顶到右边 */
    .c.solo { margin-left: auto; }
  }

  /* 手机壳 —— 让用户一眼看出这是"发出去之后的样子" */
  .phone {
    position: relative;
    width: 300px;
    margin: 0 auto;
    border: 9px solid #1f2329;
    border-radius: 30px;
    background: #fff;
    overflow: hidden;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.14);
  }
  .notch {
    position: absolute; top: 0; left: 50%; transform: translateX(-50%);
    width: 96px; height: 16px; background: #1f2329;
    border-radius: 0 0 10px 10px; z-index: 2;
  }
  .screen { min-height: 460px; display: flex; flex-direction: column; }

  .img-wrap { position: relative; background: #000; }
  .shot { width: 100%; display: block; aspect-ratio: 9 / 16; }
  .dots {
    position: absolute; bottom: 10px; left: 0; right: 0;
    display: flex; justify-content: center; gap: 5px;
  }
  .dot {
    width: 6px; height: 6px; border-radius: 50%;
    background: rgba(255, 255, 255, 0.45); cursor: pointer;
    &.on { background: #fff; }
  }
  .nav {
    position: absolute; top: 50%; transform: translateY(-50%);
    width: 26px; height: 40px; line-height: 38px; text-align: center;
    background: rgba(0, 0, 0, 0.28); color: #fff; font-size: 20px;
    cursor: pointer; user-select: none;
    &.prev { left: 0; border-radius: 0 6px 6px 0; }
    &.next { right: 0; border-radius: 6px 0 0 6px; }
    &:hover { background: rgba(0, 0, 0, 0.5); }
  }

  .note { padding: 12px 12px 14px; }
  .n-title { font-size: 14px; font-weight: 600; color: #1f2329; line-height: 1.45; }
  .n-body {
    margin-top: 7px; font-size: 12px; color: #4e5462; line-height: 1.65;
    white-space: pre-wrap;
    /* 小红书正文默认折叠，这里也只给个大概，避免右栏被超长正文撑爆 */
    max-height: 170px; overflow: hidden;
    mask-image: linear-gradient(180deg, #000 76%, transparent);
  }
  .n-tags { margin-top: 8px; }
  .tag { font-size: 12px; color: #3a5da8; margin-right: 6px; }
  .n-bar {
    margin-top: 12px; padding-top: 10px; border-top: 1px solid #f0f1f4;
    display: flex; gap: 16px; font-size: 12px; color: #8a8f98;
  }

  .placeholder {
    flex: 1; display: flex; flex-direction: column;
    align-items: center; justify-content: center; padding: 40px 26px; text-align: center;
    i { font-size: 30px; color: #c3c7ce; }
    .ph-title { margin-top: 12px; font-size: 14px; color: #606266; }
    .ph-desc { margin-top: 6px; font-size: 12px; color: #a0a4ab; line-height: 1.7; }
  }

  .p-tip { margin-top: 10px; font-size: 12px; color: #a0a4ab; text-align: center; line-height: 1.6; }
  .p-tip.pending { margin-top: 14px; color: #f0a020; }
}
</style>
